import React from "react";
import { VariableLookupText, VariableLookupTextNoDebounce } from "~/components/form/VariableLookupText";
import type { FormFieldProps } from "~/components/form/index";
interface SingleLineTextInputProps extends FormFieldProps<string> {
    label: string;
    localNames?: string[];
    warning?: string;
    defaultValueIndicator: JSX.Element | undefined;
    validate?: ((value: string) => string) | ((value: string | null) => string);
    onValidate?(value: string): void;
    withoutDebounce?: boolean;
}
const SingeLineTextInput: React.FC<SingleLineTextInputProps> = (props) => {
    const { value, label, localNames, warning, defaultValueIndicator, withoutDebounce, ...rest } = props;
    const formProps = { ...rest, label };
    return (<React.Fragment>
            {withoutDebounce ? <VariableLookupTextNoDebounce value={value} localNames={localNames} warning={warning} {...formProps}/> : <VariableLookupText value={value} localNames={localNames} warning={warning} {...formProps}/>}
            {defaultValueIndicator}
        </React.Fragment>);
};
SingeLineTextInput.displayName = "SingeLineTextInput"
export default SingeLineTextInput;
